import { render } from "./App.vue?vue&type=template&id=31e7de22&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=31e7de22&lang=less"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\工作文件\\移动端后台\\vue_test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__